import styled from '@emotion/styled';
import React, { FC, useState } from 'react';
import closedEyeIcon from 'src/public/img/eye-closed.svg';
import openEyeIcon from 'src/public/img/eye-open.svg';

const Container = styled.div({
    display: 'flex',
    paddingLeft: 5,
    position: 'relative',
    minWidth: 140,
});

const EyeIcon = styled.img({
    marginLeft: 15,
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)',
});

interface PasswordProps {
    password: string;
}

const allCharsRegex = /./g;
export const Password: FC<PasswordProps> = ({ password }) => {
    const [isPasswordVisible, setPasswordVisible] = useState(false);

    const getText = () => {
        if (isPasswordVisible) {
            return password;
        }

        return password.replace(allCharsRegex, '•');
    };

    return (
        <Container>
            <strong>{getText()}</strong>
            <EyeIcon
                src={isPasswordVisible ? openEyeIcon : closedEyeIcon}
                onClick={() => setPasswordVisible(visible => !visible)}
            />
        </Container>
    );
};
